module.exports = __webpack_public_path__ + "img/index-solutions-net-hover.a1d92618.png";